import React from 'react';

const SearchItem = ({ item, itemQuery }) => {
    // general destructuring of the item
    const { clickTrackingUrl, title, summary, listMetadata } = item;

    // get the resourse nested metadata
    const resource = listMetadata;
    // destructure elements from the resources
    const { resourceType, stage } = resource;
    // console.log(resource);

    // color applications
    let selectColor = '';
    let selectCategory = '';

    const getColor = (metadata) => {
        if (metadata !== undefined) {
            if (metadata.length > 1) {
                selectColor = 'orange';
            } else {
                switch (metadata[0]) {
                    case 'stageEarlyChildhood':
                        selectColor = 'pink';
                        break;
                    case 'stagePrimarySchool':
                        selectColor = 'green';
                        break;
                    case 'stageSecondarySchool':
                        selectColor = 'red';
                        break;
                    case 'stageLearnerNoviceDriver':
                        selectColor = 'blue';
                        break;
                    default:
                        selectColor = 'orange';
                        break;
                }
            }
        }
    };

    const getCategory = (metadata) => {
        if (metadata !== undefined) {
            if (metadata.length > 1) {
                selectCategory = '';
            } else {
                switch (metadata[0]) {
                    case 'typeLessonPlan':
                        selectCategory = 'Lesson Plan';
                        break;
                    case 'typeProgram':
                        selectCategory = 'Program';
                        break;
                    case 'typePolicy':
                        selectCategory = 'Policy';
                        break;
                    case 'typeAdditionalResource':
                        selectCategory = 'Additional Resource';
                        break;
                    default:
                        selectCategory = '';
                        break;
                }
            }
        }
    };

    getColor(stage);
    getCategory(resourceType);

    // hightligting

    const highLighting = (string, query) => {
        const parsedHtml = string.replace(
            new RegExp(query, 'gi'),
            (match) => `<strong>${match}</strong>`
        );
        return parsedHtml;
    };

    return (
        <div className="search-list__item">
            <div className="search-list__title">
                {stage && (
                    <span className={`elipses elipses--${selectColor}`} />
                )}
                <a href={clickTrackingUrl}>
                    <h5>
                        {selectCategory ? `${selectCategory}: ` : ''}
                        <span
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                                __html: highLighting(title, itemQuery),
                            }}
                        />
                    </h5>
                </a>
            </div>

            <div className="search-list__content">
                <p
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: highLighting(summary, itemQuery),
                    }}
                />
            </div>
        </div>
    );
};

export default SearchItem;
